import { css } from '@/styled-system/css';

export const triggerButton = css({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start', // Keep text and icon together
  gap: 'xs', // 4px gap between text and caret
  bg: 'transparent', // No background
  color: 'hpxTeal500', // Teal text instead of white
  border: 'none',
  padding: '0', // No padding
  cursor: 'pointer',
  fontSize: 'md', // 16px
  fontWeight: '700', // Bold
  width: 'auto', // Auto width to fit content
  textAlign: 'left', // Left-aligned text
  transitionProperty: 'all',
  transitionDuration: '0.2s',
  transitionTimingFunction: 'ease',

  _hover: {
    color: 'hpxTeal600', // Darker teal on hover
    '& svg': {
      transform: 'translateX(2px)', // Subtle icon animation
    },
  },

  _active: {
    color: 'hpxTeal700', // Even darker on active
  },

  _focusVisible: {
    outlineWidth: '2px',
    outlineStyle: 'solid',
    outlineColor: 'hpxTeal500',
    outlineOffset: '2px',
    borderRadius: '2px',
  },

  _disabled: {
    color: 'hpxGrey500',
    cursor: 'not-allowed',
    '& svg': {
      opacity: 0.5,
    },
  },
});

export const triggerText = css({
  fontSize: 'md', // 16px
  fontWeight: '700', // Bold
});
